angular.module('filters')
    .filter('versionNumber', () => (version, fractionSize) => {

        if (version) {

            return parseFloat(version).toFixed(fractionSize);

        }

        return version;

    });



// WEBPACK FOOTER //
// ./scripts/common/filters/versionNumber.js